import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  private clearSelectedCell = new Subject<any>();
  private boxesToUpdate = new Subject<any>();
  constructor(private http: HttpClient) { }


  isClearCell(): Observable<any> {
    return this.clearSelectedCell.asObservable();
  }

  markAlreadyCheckedBox(logDataToUpdate) {
    this.boxesToUpdate.next({ isUpdateCell: true, logDataToUpdate })
  }

  boxesToUpdateCall(): Observable<any> {
    return this.boxesToUpdate.asObservable();

  }

  getAttendance(params): Observable<any> {
    console.log("Getting attendance");
    const jobId = params.jobId;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "learners/attendance?jobId=" + jobId).subscribe((res: any) => {
        console.log("Get attendance : ", res);
        observer.next(res);
        observer.complete();
      })

    });
  }

  reportAttendance(data): Observable<any> {
    console.log("Getting attendance");
    // const data = data;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "learners/attendance-report", data)
        .subscribe((res: any) => {
          console.log("Get attendance : ", res);
          observer.next(res.data);
          observer.complete();
        })

    });
  }


  getAttendanceMpJob(params): Observable<any> {
    console.log("Getting attendance");
    const jobId = params.jobId;
    const linkedJob = params.linkedJob


    let str = '';

    params.linkedJob ? str = "mpJobId=" + jobId + '&linkedJob=' + linkedJob : str = "mpJobId=" + jobId;

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "tested-individual/attendance?" + str).subscribe((res: any) => {
        console.log("Get attendance in mp Job: ", res);
        observer.next(res);
        observer.complete();
      })

    });
  }




  updateAttendance(body): Observable<any> {
    console.log("Updating attendance attendance");
    return new Observable<any>((observer) => {
      console.log("Observable", body);
      this.http.put(config.baseApiUrl + "learners/attendance", body).subscribe((res: any) => {
        console.log("Update attendance : ", res);
        this.clearSelectedCell.next(body);
        observer.next(res);
        observer.complete();
      })

    });
  }

  editJobDatesList(body): Observable<any> {
    console.log("Updating date in attendance", body);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "courses/job-dates", body).subscribe((res: any) => {
        console.log("Update attendance : ", res);
        observer.next(res.data);
        observer.complete();
      },(error)=>{
       console.log("Some error occure edit job date List",error)
      })

    });
  }

  deleteRegisterDay(data): Observable<any> {
    console.log("Updating date in attendance", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "courses/delete-day", data).subscribe((res: any) => {
        console.log("Update attendance : ", res);
        observer.next(res.data);
        observer.complete();
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })

    });
  }


}
